// Optional wrapper for user management utilities
// Provides safe fallbacks for backwards compatibility

let userManagement = null

try {
  userManagement = require('./userManagement')
} catch (error) {
  console.warn('User management utilities not available:', error)
}

// Safe function wrappers
export const getAllUsers = async () => {
  if (userManagement && userManagement.getAllUsers) {
    return await userManagement.getAllUsers()
  }
  console.warn('getAllUsers not available - returning empty array')
  return []
}

export const updateToolPermissions = async (email, toolId, access, manager) => {
  if (userManagement && userManagement.updateToolPermissions) {
    return await userManagement.updateToolPermissions(email, toolId, access, manager)
  }
  console.warn('updateToolPermissions not available')
  throw new Error('User management functionality not available')
}

export const inviteUser = async (email, roles, toolPermissions, division, group, managerStatus, invitedBy) => {
  if (userManagement && userManagement.inviteUser) {
    return await userManagement.inviteUser(email, roles, toolPermissions, division, group, managerStatus, invitedBy)
  }
  console.warn('inviteUser not available')
  throw new Error('User management functionality not available')
}

export const updateUserRoles = async (email, roles) => {
  if (userManagement && userManagement.updateUserRoles) {
    return await userManagement.updateUserRoles(email, roles)
  }
  console.warn('updateUserRoles not available')
  throw new Error('User management functionality not available')
}

export const updateUserDivision = async (email, division) => {
  if (userManagement && userManagement.updateUserDivision) {
    return await userManagement.updateUserDivision(email, division)
  }
  console.warn('updateUserDivision not available')
  throw new Error('User management functionality not available')
}

export const updateUserGroup = async (email, group) => {
  if (userManagement && userManagement.updateUserGroup) {
    return await userManagement.updateUserGroup(email, group)
  }
  console.warn('updateUserGroup not available')
  throw new Error('User management functionality not available')
}

export const updateManagerStatus = async (email, groupId, isManager) => {
  if (userManagement && userManagement.updateManagerStatus) {
    return await userManagement.updateManagerStatus(email, groupId, isManager)
  }
  console.warn('updateManagerStatus not available')
  throw new Error('User management functionality not available')
}

export const getUserByEmail = async (email) => {
  if (userManagement && userManagement.getUserByEmail) {
    return await userManagement.getUserByEmail(email)
  }
  console.warn('getUserByEmail not available')
  return null
}

export const getAvailableDivisions = () => {
  if (userManagement && userManagement.getAvailableDivisions) {
    return userManagement.getAvailableDivisions()
  }
  console.warn('getAvailableDivisions not available - returning empty array')
  return []
}

export const getGroupsForDivision = (divisionId) => {
  if (userManagement && userManagement.getGroupsForDivision) {
    return userManagement.getGroupsForDivision(divisionId)
  }
  console.warn('getGroupsForDivision not available - returning empty array')
  return []
}

export const getToolsForGroup = (groupId) => {
  if (userManagement && userManagement.getToolsForGroup) {
    return userManagement.getToolsForGroup(groupId)
  }
  console.warn('getToolsForGroup not available - returning empty array')
  return []
}

export const getAllGroups = () => {
  if (userManagement && userManagement.getAllGroups) {
    return userManagement.getAllGroups()
  }
  console.warn('getAllGroups not available - returning empty array')
  return []
}

export const isGroupManager = async (email, groupId) => {
  if (userManagement && userManagement.isGroupManager) {
    return await userManagement.isGroupManager(email, groupId)
  }
  console.warn('isGroupManager not available - returning false')
  return false
}

export const getUserManagedGroups = async (email) => {
  if (userManagement && userManagement.getUserManagedGroups) {
    return await userManagement.getUserManagedGroups(email)
  }
  console.warn('getUserManagedGroups not available - returning empty array')
  return []
}

// Constants with safe fallbacks
export const DIVISIONS_AND_GROUPS = userManagement?.DIVISIONS_AND_GROUPS || {}
export const AVAILABLE_TOOLS = userManagement?.AVAILABLE_TOOLS || {}
export const AVAILABLE_ROLES = userManagement?.AVAILABLE_ROLES || []

// Legacy compatibility
export const AVAILABLE_DEPARTMENTS = userManagement?.AVAILABLE_DEPARTMENTS || []

// Deprecated but kept for backwards compatibility
export const updateUserDepartment = updateUserGroup 